// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"69":"faf94c45","390":"885720b2","453":"001b6fa2","569":"723b0f96","615":"7cd1b666","673":"e774d02a","884":"91c6a00c"}[chunkId] + ".chunk.js";
};